(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dash-delivery-estimate')) {
    customElements.define('dash-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.refreshDate = this.refreshDate || this.updateDate.bind(this);
        document.addEventListener('visibilitychange', this.refreshDate);
        this.updateDate();
      }

      disconnectedCallback() {
        clearTimeout(this.midnightTimer);
        document.removeEventListener('visibilitychange', this.refreshDate);
      }

      updateDate() {
        const output = this.querySelector('[data-delivery-date]');
        if (!output) return;
        const now = new Date();
        const arrival = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 5, 12);
        const isoDate = `${arrival.getFullYear()}-${String(arrival.getMonth() + 1).padStart(2, '0')}-${String(arrival.getDate()).padStart(2, '0')}`;
        let formatter;
        try {
          formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
        } catch {
          formatter = new Intl.DateTimeFormat('en', { weekday: 'short', day: 'numeric', month: 'short' });
        }
        output.dateTime = isoDate;
        output.textContent = formatter.format(arrival);
        clearTimeout(this.midnightTimer);
        const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        this.midnightTimer = setTimeout(this.refreshDate, midnight.getTime() - now.getTime() + 1000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
